import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { CountdownTimer } from 'src/components/Chicken/ui/countdown-timer/CountdownTimer'
import common from 'src/styles/common.module.scss'
import styles from './styles.module.scss'

export const TextHeaderSl = () => {
    return (
        <div className={styles.wrapper_content}>
            <HighlightedText
                text="Uganite, kje je denar."
                highlights={[
                    { word: 'Uganite,' },
                    { word: 'kje' },
                    { word: 'je' },
                    { word: 'denar.' },
                ]}
                className={common.text_header}
            />
            <div className={styles.wrapper}>
                <span className={styles.text}>Imate tri poskuse!</span>
                <CountdownTimer />
            </div>
        </div>
    )
}
